import type { SVGProps } from 'react';
export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M16.81 5.22c.26.28.25.73-.02 1L8.36 14.8a.65.65 0 0 1-.94 0l-4.21-4.29a.74.74 0 0 1-.02-1c.26-.29.69-.3.96-.02l3.74 3.8 7.96-8.09c.27-.27.7-.27.96.02"
      clipRule="evenodd"
    />
  </svg>
);
